import { render, staticRenderFns } from "./preViewPhoneDialog.vue?vue&type=template&id=47cf25f3&scoped=true"
import script from "./preViewPhoneDialog.vue?vue&type=script&lang=ts"
export * from "./preViewPhoneDialog.vue?vue&type=script&lang=ts"
import style0 from "./preViewPhoneDialog.vue?vue&type=style&index=0&id=47cf25f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf25f3",
  null
  
)

export default component.exports